import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  OnChanges
} from '@angular/core'
import { TableColumn } from 'src/app/core/models/interfaces/table-column'

import { CommonModule } from '@angular/common'
import { TranslatePipe } from '@ngx-translate/core'
import { TooltipModule } from 'primeng/tooltip'
import { LocalizedDatePipe } from '../../pipes/localized-date.pipe'
import { NoResultFoundComponent } from '../no-result-found/no-result-found.component'
import { PaginationComponent } from '../pagination/pagination.component'

@Component({
  selector: 'app-auditing',
  templateUrl: './auditing.component.html',
  styleUrls: ['./auditing.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    TooltipModule,
    LocalizedDatePipe,
    NoResultFoundComponent,
    PaginationComponent
  ]
})
export class AuditingComponent implements OnInit, OnChanges {
  currentLanguage = localStorage.getItem('lang')
  @Input() tableData!: any
  @Output() pageChangeEvent = new EventEmitter<any>()
  @Output() changePageCountEvent = new EventEmitter<any>()
  columns: TableColumn[] = []
  itemsPerPage = 10
  config: any = {
    id: 'advanced',
    itemsPerPage: this.itemsPerPage,
    currentPage: 1,
    totalItems: undefined
  }
  maxSize: number = 10
  autoHide: boolean = false

  constructor() {}

  ngOnInit(): void {
    this.setTableHeaders()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tableData'] && this.tableData) {
      this.tableData = changes['tableData'].currentValue
      this.config.totalItems =
        this.tableData?.totalcount || this.tableData?.length || 0
    }
  }

  setTableHeaders() {
    this.columns = [
      {
        id: '1',
        name: 'Audit.Change-Date'
      },
      {
        id: '2',
        name: 'Audit.Made-Change'
      },
      {
        id: '3',
        name: 'Audit.Action-Type'
      },
      {
        id: '4',
        name: 'Audit.field-Change'
      },
      {
        id: '5',
        name: 'Audit.Old-Value'
      },
      {
        id: '6',
        name: 'Audit.New-Value'
      }
    ]
  }

  onPageChange(event: any) {
    this.pageChangeEvent.emit(event)
  }

  changePageCount(value: any) {
    this.changePageCountEvent.emit(value)
  }
}
